const $win = $(window);
const $doc = $(document);

// Fixed element on scroll

function fixedWidget() {
	const $sticky = $('.js-sticky');
	const $intro = $('.intro');
	const $widget = $('.widget--js');
	const $mainInner = $('.main__inner--js');
	const headerHeight = $('.header').outerHeight();
	let startPosition;
	let endPosition;

	function stickyEl($el, startPosition, endPosition) {
		if ( $el.length ) {

			$el.toggleClass('fixed', $win.scrollTop() > startPosition - headerHeight - 122);
			$el.toggleClass('absolute', $win.scrollTop() + $el.innerHeight() > endPosition);
		}
	}

	function updateSidebarSticky() {
		if ( $widget.length ) {
			startPosition = $mainInner.offset().top;
			endPosition = $mainInner.innerHeight() + startPosition;

			stickyEl($widget, startPosition, endPosition);
		}
	}

	$win.on('load scroll', function(){
		updateSidebarSticky();
	});
}

export default fixedWidget;



// WEBPACK FOOTER //
// ../src/assets/js/sticky.js